import { useTranslation } from "react-i18next";
import { Modal } from "../../common";
import { Button } from "../../App.styles";

const DesignationValueModal = ({ onDismiss, show }) => {
    const { t } = useTranslation();

    return (
        <Modal onDismiss={onDismiss} show={show}>
            <div className="modal-header">
                <h4 className="modal-title" dangerouslySetInnerHTML={{ __html: t(`Designation Value`) }} />
                <button
                    type="button"
                    className="close"
                    data-dismiss="modal"
                    aria-hidden="true"
                    onClick={onDismiss}
                >
                    ×
                </button>
            </div>
            <div className="modal-body">
                <p dangerouslySetInnerHTML={{
                    __html: t(`Configure how many points or challenges are required in 
                    order to allocate the designation.`)
                }} />
            </div>
            <div className="modal-footer">
                <Button type="button" color="dark" data-dismiss="modal" onClick={onDismiss}>
                    {t(`Close`)}
                </Button>
            </div>
        </Modal>
    )
};

export default DesignationValueModal;
